import React from "react";

interface TabButtonProps {
  active: boolean;
  onClick: () => void;
  icon: React.ReactNode;
  label: string;
}

export const TabButton: React.FC<TabButtonProps> = ({ active, onClick, icon, label }) => (
  <button
    onClick={onClick}
    className={`px-6 py-3 font-medium transition-colors flex items-center gap-2 ${
      active ? "text-green-600 border-b-2 border-green-600" : "text-gray-600 hover:text-gray-900"
    }`}
  >
    {icon}
    {label}
  </button>
);
